import './App.scss';
import React, {Component} from 'react';
import MyRout from "./MyRout";
import {Provider} from "react-redux";
import {Store} from "./Store";
import Alert from "../shared/component/alert/Alert";
import Loading from '../shared/component/Loading/Loading';
import {handleDeviceSize} from "../actions/DeviceModeAction";
import TabCounter from "../helpers/TabCounter";

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        Store.dispatch(handleDeviceSize(window.innerWidth, window.innerHeight))
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        Store.dispatch(handleDeviceSize(window.innerWidth, window.innerHeight))
    }

    render() {
        return (
            <Provider store={Store}>
                <div className={'app'}>
	                {/*<TabCounter />*/}
                    <MyRout/>
                    <Alert/>
                    <Loading />
                </div>
            </Provider>
        );
    }
}
  
export default App;

